<div class="upsell-wait relative z-1">
  <div class="upsell-wait__container mx-auto px-4 pt-8 relative">
    <div class="upsell-wait__row rounded-lg flex flex-col desktop:flex-row items-center p-4 gap-8 desktop:gap-16">

      <div class="upsell-wait__iconBlock rounded-lg flex flex-row items-center gap-4">
        <img class="upsell-wait__icon self-center w-26 h-36 desktop:w-44 desktop:h-44" src="{{ iconWait }}" alt="">
      </div>

      <div class="upsell-wait__description text-center desktop:text-left"> 
        <h3 class="text-2xl" [innerHTML]="title"></h3>
        <p class="" [innerHTML]="description"></p>
      </div>
 
    </div>
  </div>
</div>